// extracted by mini-css-extract-plugin
module.exports = {"button":"CartButton_button__PzdGt","icon":"CartButton_icon__1TGpt","badge":"CartButton_badge__ZxJKw","bump":"CartButton_bump__2KCIK"};